import { nullCheck } from "../utils/dataHelpers";
import { parseMcleodDate, formatDateForMcleod } from "../utils/dateHelpers";

export default class CarrierPostedTruckSerializer {
  static serialize(data) {
    const payload = {
      ...data,
      __type: "avail_tract_detail",
      company_id: "TMS",
      avail_tract_id: data.availTractId,
      available_date: formatDateForMcleod(data.startDate),
      carrier_email: data.carrierEmail,
      carrier_fax: data.carrierFax,
      carrier_id: data.carrierId,
      carrier_phone: data.carrierPhone,
      city_id: data.originCityId,
      comments: data.comments,
      contact: data.contact,
      contact_web: data.contactWeb,
      date_entered: formatDateForMcleod(data.postedDate),
      dispatcher: data.dispatcher,
      distance_radius: data.distanceRadius,
      entered_by: data.postedBy,
      equipment_type_id: data.equipmentTypeId,
      expires_date: formatDateForMcleod(data.expiryDate),
      extracted_capacity: data.extractedCapacity,
      load_to_city: data.destinationCity,
      load_to_state: data.destinationState,
      dest_city_id: data.destinationCityId,
      location_city: data.originCity,
      location_state: data.originState,
      location_zip: data.locationZip,
      location_zone_id: data.locationZoneId,
      number_units: data.numberUnits,
      recurring_tractor_id: data.recurringTractorId,
      status: data.status,
      teams: data.teams,
      tractor_id: data.tractorId,
      date_updated: formatDateForMcleod(data.dateUpdated),
      updated_by: data.updatedBy,
      proposed_cost: data.proposedCost,
      proposed_rpm: data.proposedRpm,
      lane_miles: data.miles
    };

    const customProperties = [
      "availTractId",
      "startDate",
      "carrierEmail",
      "carrierFax",
      "carrierId",
      "carrierPhone",
      "originCityId",
      "contactWeb",
      "postedDate",
      "distanceRadius",
      "postedBy",
      "equipmentTypeId",
      "expiryDate",
      "extractedCapacity",
      "destinationCity",
      "destinationState",
      "destinationCityId",
      "originCity",
      "originState",
      "locationZip",
      "locationZoneId",
      "numberUnits",
      "recurringTractorId",
      "tractorId",
      "dateUpdated",
      "updatedBy",
      "proposedCost",
      "proposedRpm"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      __type: "avail_tract_detail",
      company_id: "TMS",
      availTractId: data.avail_tract_id,
      startDate: parseMcleodDate(data.available_date),
      carrierEmail: data.carrier_email,
      carrierFax: data.carrier_fax,
      carrierId: data.carrier_id,
      carrierPhone: data.carrier_phone,
      originCityId: data.city_id,
      comments: data.comments,
      contact: data.contact,
      contactWeb: data.contact_web,
      postedDate: parseMcleodDate(data.date_entered),
      dispatcher: data.dispatcher,
      dispatcherUserName: nullCheck(data, "", "entered_by_row",  "name"),
      distanceRadius: data.distance_radius,
      postedBy: data.entered_by,
      equipmentTypeId: data.equipment_type_id,
      expiryDate: parseMcleodDate(data.expires_date),
      extractedCapacity: data.extracted_capacity,
      destinationCity: data.load_to_city,
      destinationState: data.load_to_state,
      destinationCityId: data.dest_city_id,
      originCity: data.location_city,
      originState: data.location_state,
      locationZip: data.location_zip,
      locationZoneId: data.location_zone_id,
      numberUnits: data.number_units,
      recurringTractorId: data.recurring_tractor_id,
      status: data.status,
      teams: data.teams,
      tractorId: data.tractor_id,
      dateUpdated: parseMcleodDate(data.date_updated),
      updatedBy: data.updated_by,
      proposedCost: data.proposed_cost,
      proposedRpm: data.proposed_rpm,
      miles: data.lane_miles
    };
  }
}